/**
 * Zustand store for IWT Adjacency Map state management.
 *
 * Combines five slices into a single store. SP slice removed —
 * platform SSO and REST API replace MSAL + SharePoint sync.
 */

import { create } from 'zustand';
import type { AdjacencyStoreState } from './store-types';
import { createDataSlice } from './data-slice';
import { createUiSlice } from './ui-slice';
import { createHistorySlice } from './history-slice';
import { createRelationshipSlice } from './relationship-slice';
import { createResourceSlice } from './resource-slice';

export type { AdjacencyStoreState };

export const useAdjacencyStore = create<AdjacencyStoreState>()((...a) => ({
  ...createDataSlice(...a),
  ...createUiSlice(...a),
  ...createHistorySlice(...a),
  ...createRelationshipSlice(...a),
  ...createResourceSlice(...a),
}));
